import IconEyeSlashSolid from '@/assets/icons/font_awesome/eye-slash-solid.svg?react';
import IconEyeSolid from '@/assets/icons/font_awesome/eye-solid.svg?react';
import { ICON__lock } from '@/assets/icons_fa';
import { UI_PRIMITIVE__icon_animated } from '@/components/ui/UI_PRIMITIVE__icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_slice_ui } from '@/hooks/store/use_slices';
import i18n_page_auth from '@/locales/keys/i18n_page_auth.json';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UI_PRIMITIVE__input } from '../../../components/ui/UI_PRIMITIVE__input';
import { ENUM__i18n_namespace } from '../../../services/i18n/ENUM__i18n_namespace';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  isLoading?: boolean;
}

export const A_INPUT__password = React.forwardRef<HTMLInputElement, Props>(({ isLoading, ...props }, ref) => {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_AUTH);

  const { page_auth_is_loading } = use_slice_ui(['page_auth_is_loading']);

  const [show_password, set_show_password] = useState(false);
  const [isIconShowPasswordHovered, setIsIconShowPasswordHovered] = useState(false);

  return (
    <UI_PRIMITIVE__input
      type={show_password ? 'text' : 'password'}
      placeholder={t(i18n_page_auth.auth_component.input.password_placeholder)}
      disabled={page_auth_is_loading}
      iconStart={
        <UI_PRIMITIVE__icon_animated
          className="!size-4 pointer-events-none"
          Icon={ICON__lock}
          renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        />
      }
      iconEnd={
        <UI_PRIMITIVE__icon_animated
          className={`cursor-pointer !size-4 hover-animation-important ${isIconShowPasswordHovered ? '' : 'text-component-item-foreground'}`}
          onMouseEnter={() => setIsIconShowPasswordHovered(true)}
          onMouseLeave={() => setIsIconShowPasswordHovered(false)}
          Icon={show_password ? IconEyeSlashSolid : IconEyeSolid}
          onClick={() => set_show_password(!show_password)}
          renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        />
      }
      ref={ref}
      {...props}
    />
  );
});
A_INPUT__password.displayName = 'APasswordInput';
